import { type PIN_IMAGES } from '../Map.constants';

import type { PinData } from '../Map.types';

/**
 * Returns the appropriate pin image key based on pin properties.
 * This function is shared between native and web implementations.
 */
export function getPinImageKey(pin: PinData): PinImageKey {
  const {
    acceptingOrders,
    deliveryAddressType,
    isSelectedLocation,
    isDeliveryAddress,
    isCustomer,
    isMinimized,
    isCourier,
    isOutpost,
    brandIconSrc,
  } = pin;

  if (isCustomer) return 'pin-customer';

  if (isCourier) return 'pin-courier';

  if (isSelectedLocation) return 'pin-location';

  if (isDeliveryAddress) {
    if (brandIconSrc) return 'pin-brand';

    if (deliveryAddressType === 'home') return 'pin-home';
    if (deliveryAddressType === 'work') return 'pin-work';

    return 'pin-custom';
  }

  if (isMinimized && acceptingOrders) return 'pin-minimized-open';

  if (isMinimized && !acceptingOrders) return 'pin-minimized-closed';

  if (brandIconSrc && acceptingOrders) return 'pin-brand';

  if (isOutpost) {
    return acceptingOrders ? 'pin-outpost' : 'pin-outpost-closed';
  }

  if (!acceptingOrders) return 'pin-pickup-closed';

  return 'pin-pickup';
}

// ─── Types ───────────────────────────────────────────────────────────────────

type PinImageKey = keyof typeof PIN_IMAGES | 'pin-brand';
